import { FormControl, FormHelperText, Stack, Typography } from "@mui/material";
import { useFormikContext } from "formik";
import React from "react";

import { initialValue } from "../../Form/helpers";
import { QuestionProps } from "../interfaces";
import { StyledRating } from "../StyledRating";

const RatingQuestion: React.FC<QuestionProps> = ({ question, saveDraft, ...props }) => {
    const { values, getFieldMeta, errors, setFieldValue } = useFormikContext<Record<string, initialValue>>();
    const error = errors[question.id];
    const formValue = values[question.id];

    const { touched } = getFieldMeta(`${question.id}.value`);

    if (!formValue || !question.maxRating) {
        return null;
    }

    return (
        <FormControl sx={{ width: "100%" }} error={touched && Boolean(error)}>
            <StyledRating
                max={question.maxRating}
                value={Number(formValue.value)}
                disabled={props.disabled}
                onChange={(_, v) => {
                    if (!v) return;
                    setFieldValue(question.id, { value: v.toString(), fileNames: formValue.fileNames });
                    saveDraft([v.toString()]);
                }}
            />
            <FormHelperText>
                <Stack direction="row" justifyContent="flex-start">
                    <Typography>{touched && error ? error.value : ""}</Typography>
                </Stack>
            </FormHelperText>
        </FormControl>
    );
};

export default RatingQuestion;
